<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.activeIngredientId"
          v-bind="getObject('activeIngredientId')"
          label="Ingrediente Ativo"
          :items="extraData.adminContext.allActiveIngredients"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          @input="selectActiveIngredient"
        >
          <template v-slot:append-outer>
            <ActiveIngredientNew
              :inlineAddButton="true"
              @entry-created="activeIngredientCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('concentration')"
          :inputData.sync="entry.concentration"
          mask-type="currency_10d"
          label="Concentração"
          suffix="%"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import ActiveIngredientNew from "@models/items/agrotoxics/active_ingredients/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";


export default {
  data() {
    return {
      entryAttributes: {},
      renderComponent: true,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    initialDate: {
      type: String,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    ActiveIngredientNew: ActiveIngredientNew,
    BaseUtil: BaseUtil,
    DateField: DateField
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectActiveIngredient: function() {
      this.entry.activeIngredient = this.extraData.adminContext.allActiveIngredients.find(obj => obj.id == this.entry.activeIngredientId);
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    activeIngredientCreated: function(activeIngredient) {
      this.extraData.adminContext.allActiveIngredients.unshift(activeIngredient);
      this.entry.activeIngredientId = activeIngredient.id;
      this.entry.activeIngredient = activeIngredient;
    }, 
  }
};


</script>

<style scoped></style>
